import {List, Typography} from 'antd';
import {FileTextOutlined, SearchOutlined, UserDeleteOutlined, UserOutlined, CrownOutlined, EditOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import {PageTitle} from "../../components/PageTitle.tsx";
import {useSubscriptionEndDate} from '../../hooks/useSubscriptionEndDate';

const {Text} = Typography;

const menuItems = [
    {
        icon: <FileTextOutlined/>,
        title: "Vorlagen",
        description: "Managen Sie Ihre Vorlagen für die Kandidatenansprache",
        path: "/templates"
    },
    {
        icon: <UserOutlined/>,
        title: "Zugangsdaten",
        description: "Ändern Sie Ihr Passwort oder Ihre Emailadresse",
        path: "/privacy"
    },
    {
        icon: <SearchOutlined/>,
        title: "Meine Suchen",
        description: "Managen Sie Ihre gespeicherten Suchen",
        path: "/searches"
    },
    {
        icon: <CrownOutlined/>,
        title: "Meine silver+ Mitgliedschaft",
        description: "Verwalten Sie Ihr Abonnement",
        path: "/account/silverplus-membership"
    },
    {
        icon: <EditOutlined/>,
        title: "Silver+ Tarif ändern",
        description: "Ändern Sie Ihren Silver+ Tarif",
        path: "/silverplus/subscription"
    },
    {
        icon: <UserDeleteOutlined/>,
        title: "Konto löschen",
        description: "Löschen Sie Ihr silvertalent Konto",
        path: "/delete-profile"
    }
];


export const Account = () => {
    const { endDate } = useSubscriptionEndDate();

    // Check if subscription is active (end date is valid and in the future)
    const hasActiveSubscription = endDate && !isNaN(endDate.getTime()) && endDate > new Date();

    // Filter menu items based on user type and subscription status
    const filteredMenuItems = menuItems.filter(item => {
        // Hide delete account for users with active subscription (end date in future)
        if (item.path === '/delete-profile' && hasActiveSubscription) {
            return false;
        }
        // Only show silver+ membership for paid users
        if (item.path === '/account/silverplus-membership' && !hasActiveSubscription) {
            return false;
        }
        // Only show silver+ tarif ändern for paid users
        if (item.path === '/silverplus' && !hasActiveSubscription) {
            return false;
        }
        return true;
    });

    return (
        <div>
            <PageTitle title="Mein Konto"/>

            <List
                itemLayout="horizontal"
                dataSource={filteredMenuItems}
                renderItem={(item) => (
                    <List.Item>
                        <Link to={item.path} style={{display: 'block', width: '100%'}}>
                            <List.Item.Meta
                                avatar={item.icon}
                                title={<Text strong>{item.title}</Text>}
                                description={item.description}
                            />
                        </Link>
                    </List.Item>
                )}
            />
        </div>
    );
};
